import { render, staticRenderFns } from "./ThumbnailCardsBlock.vue?vue&type=template&id=01d39f56&scoped=true&"
import script from "./ThumbnailCardsBlock.vue?vue&type=script&lang=js&"
export * from "./ThumbnailCardsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ThumbnailCardsBlock.vue?vue&type=style&index=0&id=01d39f56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d39f56",
  null
  
)

export default component.exports